module.exports = __webpack_public_path__ + "img/Cross Icon - charcoal.7ccbe93a.svg";